"use strict";

exports.__esModule = true;
var _AsyncLoader = require("./AsyncLoader");
Object.keys(_AsyncLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AsyncLoader[key]) return;
  exports[key] = _AsyncLoader[key];
});